module.exports = __webpack_public_path__ + "static/img/banner.8bb14f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/基因调控/甲基化检测/banner.png
// module id = Rmuc
// module chunks = 16